var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLangChina(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2940_57508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 34C30.4183 34 34 30.4183 34 26C34 21.5817 30.4183 18 26 18C21.5817 18 18 21.5817 18 26C18 30.4183 21.5817 34 26 34Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3781 22.8672L23.0687 24.9922H25.3031L23.4969 26.3078L24.1875 28.4328L22.3781 27.1203L20.5688 28.4328L21.2625 26.3078L19.4531 24.9922H21.6875L22.3781 22.8672Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4845 30.3898L26.9563 29.7398L26.1751 30.043L26.6282 29.3398L26.1001 28.6867L26.9095 28.9023L27.3657 28.1992L27.4095 29.0367L28.222 29.2523L27.4376 29.5523L27.4845 30.3898Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5345 28.4836L28.7845 27.6836L28.1001 27.1992L28.9376 27.1867L29.1845 26.3867L29.4563 27.1805L30.2938 27.1711L29.622 27.6711L29.8907 28.4648L29.2063 27.9805L28.5345 28.4836Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9499 23.8715L29.5812 24.6246L30.1812 25.209L29.353 25.0902L28.9843 25.8402L28.8405 25.0152L28.0093 24.8965L28.753 24.5059L28.6093 23.6777L29.2093 24.2621L29.9499 23.8715Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5064 21.5898L27.4439 22.4242L28.2221 22.7398L27.4064 22.9398L27.3471 23.7773L26.9064 23.0648L26.0908 23.2648L26.6314 22.6242L26.1877 21.9148L26.9658 22.2305L27.5064 21.5898Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2940_57508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangChina);
export default __webpack_public_path__ + "static/media/lang-China.68946a423dbfb15c01853dc816c18b82.svg";
export { ForwardRef as ReactComponent };